import {toast} from 'react-toastify';
let toastSetting:any = {
  position: "top-right",
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
}
const Toast = {
  success: (message:any, timer=2000) => {
    toastSetting["autoClose"] = timer;
    toast.success(message, toastSetting);
  },
  error: (message:any, timer=2000) => {
    toastSetting["autoClose"] = timer;
    toast.error(message, toastSetting);
  },
  info: (message:any, timer=2000, position="top-right") => {
    toastSetting["autoClose"] = timer;
    toastSetting["position"] = position;
    toast.info(message, toastSetting);
  },
  warning: (message:any, timer=2000) => {
    toastSetting["autoClose"] = timer;
    toast.warn(message, toastSetting);
  },
  // Add more methods as needed for different types of notifications
};

export default Toast;
